export default __webpack_public_path__ + "static/media/pdf.4290d33b.svg";